function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M8.58337 9.91269C8.58337 10.3269 8.91916 10.6627 9.33337 10.6627C9.74759 10.6627 10.0834 10.3269 10.0834 9.91269H8.58337ZM15.0266 9.91269C15.0266 10.3269 15.3624 10.6627 15.7766 10.6627C16.1908 10.6627 16.5266 10.3269 16.5266 9.91269H15.0266ZM16.5266 9.91269V4.51227H15.0266V9.91269H16.5266ZM16.5266 4.51227C16.5266 2.27727 14.7749 0.416656 12.555 0.416656V1.91666C13.8936 1.91666 15.0266 3.0518 15.0266 4.51227H16.5266ZM12.555 0.416656C10.3351 0.416656 8.58337 2.27727 8.58337 4.51227H10.0834C10.0834 3.0518 11.2164 1.91666 12.555 1.91666V0.416656ZM8.58337 4.51227V9.91269H10.0834V4.51227H8.58337Z",
  fill: "#627080"
});

var _ref2 = /*#__PURE__*/React.createElement("mask", {
  id: "path-2-inside-1",
  fill: "white"
}, /*#__PURE__*/React.createElement("rect", {
  x: 4.05554,
  y: 6.44446,
  width: 16.8889,
  height: 15.8333,
  rx: 1
}));

var _ref3 = /*#__PURE__*/React.createElement("rect", {
  x: 4.05554,
  y: 6.44446,
  width: 16.8889,
  height: 15.8333,
  rx: 1,
  stroke: "#627080",
  strokeWidth: 3,
  mask: "url(#path-2-inside-1)"
});

const SvgCartFashion = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref, _ref2, _ref3);

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgCartFashion, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Cart-fashion.e6220076.svg";
export { ForwardRef as ReactComponent };